export const environment = {
  production: false,
  hmr: false,
  debug: false,
  client: 'FCA-MX',
  hostName: 'https://staging-engage.chryslermxleads.com',
  environmentName: 'staging',
  appName: 'Stellantis MX Analytics',
  ssoPassword: 'ShiftDigital#123',
  defaultChartColors: ['#737373', '#000', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  applicationInsights: {
    instrumentationKey: '56d23066-d7c2-40cc-87a8-7a4a8cf6c9ef'
  },
  defaultLocale: 'en',
  availableLocales: ['en','es-MX'],
  timeZone: 'Eastern Standard Time',
  numberOfMonthsToShowDefault: 13,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  baseApiUri: '/api',
  authUri: '/token',
  baseV5ApiUri: 'https://fcamx-analytics-apiv5-staging.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: true,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/fca-mx/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
  v5Reports: []
};
